import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@storable/canaveral-components';
import Button from '../../../../../modules/react/components/stateless/Button';
import Form from '../../../../../modules/react/components/stateful/Form';
import Field from '../../../../../modules/react/components/stateful/Field';
import FacilitySelectInput from '../../../../web/containers/form/inputs/FacilitySelectInput';
import styles from './FacilityIdModal.scss';

const propTypes = {
  facility: PropTypes.shape({
    id: PropTypes.string,
    displayName: PropTypes.string,
    address: PropTypes.shape({
      fullAddress: PropTypes.string,
    }),
  }).isRequired,
  live: PropTypes.bool.isRequired,
  livePages: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

class FacilityIdModal extends React.Component {
  state = {
    formData: null,
  }

  renderConfirmation = () => {
    const { formData } = this.state;
    const { live, livePages, onSubmit } = this.props;

    let message = 'Are You Sure?';

    const livePage = live && livePages.find(page =>
      page.facilityId && page.facilityId === formData.facilityId);

    if (livePage) {
      message = `
        You already have a live version of a page with this Facility ID.
        Do you want to replace the current live version with this version?
      `;
    }

    return (
      <React.Fragment>
        <Modal.Body>
          <p className={styles.confirm}>{message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.setState({ formData: null })}>
            Back
          </Button>
          <Button onClick={() => onSubmit(formData, livePage)} variant="success">
            Confirm
          </Button>
        </Modal.Footer>
      </React.Fragment>
    );
  }

  renderForm = () => {
    const {
      onClose,
      facility: {
        id,
        displayName,
        address: { fullAddress },
      },
    } = this.props;

    return (
      <Form form="facilityIdForm" onSubmit={e => this.setState({ formData: e })}>
        <Modal.Body>
          <h4 className={styles.title}>Current Facility</h4>
          <div className={styles.currentFacility}>
            <div>{displayName}</div>
            <div>{fullAddress}</div>
            <div>{id}</div>
          </div>
          <Field
            component={FacilitySelectInput}
            facilityId={id}
            label="New Facility"
            name="facilityId"
            emptyOption=""
            required
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" variant="success">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    );
  }

  render() {
    const { formData } = this.state;
    const { onClose } = this.props;

    return (
      <Modal
        show
        onDismiss={onClose}
        aria-labelledby="facility-id-modal"
      >
        <Modal.Header>
          <Modal.Title id="updateFacilityId">Update Facility ID</Modal.Title>
        </Modal.Header>
        {formData ? this.renderConfirmation() : this.renderForm()}
      </Modal>
    );
  }
}

FacilityIdModal.propTypes = propTypes;

export default FacilityIdModal;
